import AppLayout from '@/components/AppLayout.tsx';
import { ConfigProvider, Spin } from 'antd';
import React, { Suspense } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import en from './i18n/en.json';
import ptBR from './i18n/pt-BR.json';

const WelcomePage = React.lazy(() => import('@/pages/Welcome'));

import { BackendFetch, DevTools, FormatSimple, Tolgee, TolgeeProvider } from '@tolgee/react';
import RegisterPage from './pages/Register';

const tolgee = Tolgee()
  .use(DevTools())
  .use(FormatSimple())
  .use(BackendFetch())
  // replace with .use(FormatIcu()) for rendering plurals, foramatted numbers, etc.
  .init({
    language: localStorage.getItem('LANG') || 'en',
    fallbackLanguage: 'en',

    availableLanguages: ['en', 'pt-BR'],
    projectId: 5,

    // for development
    apiUrl: import.meta.env.VITE_APP_TOLGEE_API_URL,
    apiKey: import.meta.env.VITE_APP_TOLGEE_API_KEY,

    // for production
    staticData: {
      en: en,
      'pt-BR': ptBR,
    },
    tagNewKeys: ['draft'],
  });
export default function App() {
  return (
    <Suspense fallback={<Spin />}>
      <TolgeeProvider
        tolgee={tolgee}
        fallback="Loading..." // loading fallback
      >
        <ConfigProvider theme={{
          components: {
            Card: {
              bodyPadding: 12
            }
          }
        }}>

          <BrowserRouter>
            <main>
              <Routes>
                <Route path="/" element={<AppLayout />} >
                  <Route path='/' index element={<RegisterPage />} />
                  <Route path='welcome' element={<WelcomePage />} />
                </Route>
              </Routes>
            </main>
          </BrowserRouter>
        </ConfigProvider>
      </TolgeeProvider>
    </Suspense>
  );
}
